export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string
  passing_score: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
    this.passing_score = sumupGroup.passing_score;
  }
}

export class RankResult {
  room_name: string
  student_no_character: string
  student_name: string
  curriculumResults: CurriculumResult[]
  additions: Addition[]
  isSelected: boolean
  rowObject: any = {}
  colCount: number
  scoreKeys: number[] = []
  rankKeys: number[] = []
  stdScoreKeys: number[] = []
  isPassing: boolean

  constructor(rankResult: any){
    this.room_name = rankResult.room_name;
    this.student_no_character = rankResult.student_no_character;
    this.student_name = rankResult.student_name;
    this.curriculumResults = rankResult.curriculum_results.map((x: any) => new CurriculumResult(x));
    this.additions = rankResult.additions.map((x: any) => new Addition(x));
    this.isPassing = rankResult.passing_text == "○";

    let i = 0;
    this.rowObject[i++] = this.student_no_character;
    this.rowObject[i++] = this.student_name;
    this.rowObject[i++] = this.additions.length > 0 ? this.student_no_character : null;
    for(const curriculumResult of this.curriculumResults){
      this.scoreKeys.push(i);
      this.rowObject[i++] = curriculumResult.score;
      this.rankKeys.push(i);
      this.rowObject[i++] = curriculumResult.rank;
      this.stdScoreKeys.push(i);
      this.rowObject[i++] = curriculumResult.std_score;
    }
    
    if(rankResult.passing_text){
      this.rowObject[i++] = rankResult.passing_text;
    }
    this.colCount = i;
  }
}

export class CurriculumResult {
  score: string
  rank: string
  std_score: string

  constructor(curriculumResult: any){
    this.score = curriculumResult.score;
    this.rank = curriculumResult. rank;
    this.std_score = curriculumResult.std_score;
  }
}

export class Addition {
  curriculum_id: number
  text: string

  constructor(addition: any){
    this.curriculum_id = addition.curriculum_id;
    this.text = addition.text;
  }
}

export class SearchCondtion {
  room_name: string = ""
  student_name: string = ""
  student_no_character: string = ""
}

export class AverageResult {
  curriculum_name: string
  avg_score: number
 
  constructor(averageResult: any){
    this.curriculum_name = averageResult.curriculum_name;
    this.avg_score = averageResult.avg_score;
  }
}